import { Link } from 'react-router';
import { SIDETITLER, useSidehode } from '../lib/sidehode';

/**
 * Siden som ikke finnes.
 *
 * Serveren svarer `404` på adressen før denne tegnes (se
 * `apps/api/src/shared/ruter.ts`), så en søkemotor vet alt at det ikke er noe
 * her. Tittelen settes for den som kom hit ved å klikke seg feil inne i appen,
 * uten at siden ble lastet på nytt.
 */
export function NotFoundPage() {
  useSidehode(SIDETITLER.ikkeFunnet, window.location.pathname);
  return (
    <div className="onboarding">
      <div className="onboarding-card center">
        <h1>Her var det tomt</h1>
        <p className="lead">Siden finnes ikke, eller så har den flyttet på seg.</p>
        <Link className="btn btn-primary" to="/">
          Til forsiden
        </Link>
      </div>
    </div>
  );
}
